import Sidebar from '../components/client/sidebar';
import Header from '../components/header';
import { Outlet } from "react-router";
const Clientlayout = ({children}) =>{
     return(
        <>  
           <div class="wrapper">
                <Sidebar/>
                <div class="main-panel">
                <Header/>
                        <div class="container">
                            <div class="page-inner">
                                {/* <Outlet/> */}
                                {children}
                            </div>
                        </div>
                </div>
            </div>
        </>
     );
}

export default Clientlayout;